// Generated from fixed build58. Run scripts/generate-badge-reference.cjs.
const categoryCopy = {
  GOALS: {
    name: { ko: '목표 달성', en: 'Goals' },
    description: { ko: '스스로 정한 음악 목표', en: 'Music goals you set for yourself' },
  },
  RECORDING: {
    name: { ko: '기록', en: 'Recording' },
    description: { ko: '듣고 남긴 감상 기록', en: 'A record of what you listened to' },
  },
  EXPLORATION: {
    name: { ko: '탐색', en: 'Exploration' },
    description: { ko: '시대와 장르를 넘는 발견', en: 'Discoveries across eras and genres' },
  },
  DISCOVERY: {
    name: { ko: '발견', en: 'Discovery' },
    description: {
      ko: '앱 곳곳에서 만난 음악과 회원',
      en: 'Music and people discovered across Postpop',
    },
  },
  SHARING: {
    name: { ko: '공유', en: 'Sharing' },
    description: { ko: '밖으로 건넨 음악 취향', en: 'Music tastes shared beyond Postpop' },
  },
  CURATION: {
    name: { ko: '큐레이션', en: 'Curation' },
    description: { ko: '나만의 음악 묶음', en: 'Music collections made your way' },
  },
  COMMUNITY: {
    name: { ko: '커뮤니티', en: 'Community' },
    description: { ko: '함께 나눈 음악 이야기', en: 'Music conversations shared with others' },
  },
  STREAK: {
    name: { ko: '연속 활동', en: 'Streaks' },
    description: { ko: '꾸준히 이어간 음악 생활', en: 'A music life kept in motion' },
  },
  MASTERY: {
    name: { ko: '종합 업적', en: 'Mastery' },
    description: { ko: '앱 전반에 걸쳐 쌓은 음악 생활', en: 'Achievements earned across Postpop' },
  },
  COLLECTION: {
    name: { ko: '컬렉션', en: 'Collection' },
    description: { ko: '모아 온 활동 배지', en: 'The activity badges you have collected' },
  },
  SEASONAL: {
    name: { ko: '시즌 · 숨은 업적', en: 'Seasonal · Hidden' },
    description: { ko: '특별한 시기에 발견하는 기록', en: 'Achievements found at special moments' },
  },
};
const badgeCopy = {
  goal_first: {
    name: { ko: '첫 목표', en: 'First Goal' },
    description: {
      ko: '주간 또는 월간 음악 목표를 처음 모두 달성해요.',
      en: 'Complete every goal in a weekly or monthly music plan for the first time.',
    },
  },
  goal_three_months: {
    name: { ko: '세 달의 리듬', en: 'Three Months in Rhythm' },
    description: {
      ko: '서로 다른 세 달의 음악 목표를 모두 달성해요.',
      en: 'Complete every music goal in three different months.',
    },
  },
  goal_week_streak_4: {
    name: { ko: '네 번의 약속', en: 'Four Promises Kept' },
    description: {
      ko: '서로 다른 4주의 음악 목표를 모두 달성해요.',
      en: 'Complete every music goal in four different weeks.',
    },
  },
  goal_six_months: {
    name: { ko: '반년의 약속', en: 'A Six-Month Promise' },
    description: {
      ko: '서로 다른 6개월의 음악 목표를 모두 달성해요.',
      en: 'Complete every music goal in six different months.',
    },
  },
  goal_week_streak_12: {
    name: { ko: '계절의 리듬', en: 'A Season in Rhythm' },
    description: {
      ko: '서로 다른 12주의 음악 목표를 모두 달성해요.',
      en: 'Complete every music goal in 12 different weeks.',
    },
  },
  ratings_10: {
    name: { ko: '첫 열 장', en: 'The First Ten' },
    description: { ko: '서로 다른 앨범 10장을 평가해요.', en: 'Rate 10 different albums.' },
  },
  reviews_first: {
    name: { ko: '첫 감상', en: 'First Impression' },
    description: { ko: '첫 번째 본문 리뷰를 남겨요.', en: 'Write your first album review.' },
  },
  reviews_25: {
    name: { ko: '리뷰 노트', en: 'Review Notes' },
    description: {
      ko: '서로 다른 앨범 25장에 리뷰를 남겨요.',
      en: 'Write reviews for 25 different albums.',
    },
  },
  ratings_50: {
    name: { ko: '쉰 장의 기억', en: 'Fifty Albums Remembered' },
    description: { ko: '서로 다른 앨범 50장을 평가해요.', en: 'Rate 50 different albums.' },
  },
  ratings_100: {
    name: { ko: '백 장의 귀', en: 'An Ear for a Hundred' },
    description: { ko: '서로 다른 앨범 100장을 평가해요.', en: 'Rate 100 different albums.' },
  },
  reviews_50: {
    name: { ko: '오십 편의 기록', en: 'Fifty Reviews on Record' },
    description: {
      ko: '서로 다른 앨범 50장에 리뷰를 남겨요.',
      en: 'Write reviews for 50 different albums.',
    },
  },
  track_ratings_25: {
    name: { ko: '곡을 듣는 귀', en: 'An Ear for Tracks' },
    description: { ko: '서로 다른 곡 25개를 평가해요.', en: 'Rate 25 different tracks.' },
  },
  decades_5: {
    name: { ko: '시간 여행자', en: 'Time Traveler' },
    description: {
      ko: '5개 발매 연대의 앨범을 평가해요.',
      en: 'Rate albums released across five decades.',
    },
  },
  genres_10: {
    name: { ko: '장르 탐험가', en: 'Genre Explorer' },
    description: { ko: '10개 장르의 앨범을 평가해요.', en: 'Rate albums across 10 genres.' },
  },
  decades_8: {
    name: { ko: '세기의 산책자', en: 'Across Eight Decades' },
    description: {
      ko: '8개 발매 연대의 앨범을 평가해요.',
      en: 'Rate albums released across eight decades.',
    },
  },
  genres_20: {
    name: { ko: '경계 없는 귀', en: 'Ears Without Borders' },
    description: { ko: '20개 장르의 앨범을 평가해요.', en: 'Rate albums across 20 genres.' },
  },
  members_explored_10: {
    name: { ko: '취향의 이웃', en: 'Taste Neighbors' },
    description: {
      ko: '서로 다른 회원 10명의 음악 기록을 살펴봐요.',
      en: 'Explore the music records of 10 different members.',
    },
  },
  members_explored_30: {
    name: { ko: '취향의 골목', en: 'A Lane of Tastes' },
    description: {
      ko: '서로 다른 회원 30명의 음악 기록을 살펴봐요.',
      en: 'Explore the music records of 30 different members.',
    },
  },
  members_explored_100: {
    name: { ko: '백 개의 취향 지도', en: 'A Map of One Hundred Tastes' },
    description: {
      ko: '서로 다른 회원 100명의 음악 기록을 살펴봐요.',
      en: 'Explore the music records of 100 different members.',
    },
  },
  saves_10: {
    name: { ko: '다시 들을 목록', en: 'Saved for Later' },
    description: {
      ko: '앨범·리뷰·플리를 10개 저장해요.',
      en: 'Save 10 albums, reviews, or playlists.',
    },
  },
  saves_50: {
    name: { ko: '나만의 음악 서가', en: 'My Music Shelf' },
    description: {
      ko: '앨범·리뷰·플리를 50개 저장해요.',
      en: 'Save 50 albums, reviews, or playlists.',
    },
  },
  discoveries_25: {
    name: { ko: '스물다섯 번의 발견', en: 'Twenty-Five Discoveries' },
    description: {
      ko: '서로 다른 음악 콘텐츠 25개를 탐색해요.',
      en: 'Explore 25 different pieces of music content.',
    },
  },
  discoveries_100: {
    name: { ko: '백 번의 발견', en: 'One Hundred Discoveries' },
    description: {
      ko: '서로 다른 음악 콘텐츠 100개를 탐색해요.',
      en: 'Explore 100 different pieces of music content.',
    },
  },
  shares_first: {
    name: { ko: '첫 번째 건넴', en: 'The First Share' },
    description: {
      ko: '음악 기록을 처음 외부에 공유해요.',
      en: 'Share a music record outside Postpop for the first time.',
    },
  },
  shares_3: {
    name: { ko: '취향을 건네는 사람', en: 'Passing It On' },
    description: {
      ko: '서로 다른 음악 기록을 3번 공유해요.',
      en: 'Share three different music records.',
    },
  },
  shares_20: {
    name: { ko: '스무 번의 음악 편지', en: 'Twenty Music Letters' },
    description: {
      ko: '서로 다른 음악 기록을 20번 공유해요.',
      en: 'Share 20 different music records.',
    },
  },
  mastery_1: {
    name: { ko: '취향의 설계자', en: 'Taste Architect' },
    description: {
      ko: '포스트팝의 여러 활동을 고르게 시작해요.',
      en: 'Build a balanced foundation across Postpop activities.',
    },
  },
  mastery_2: {
    name: { ko: '음악 생활의 장인', en: 'Music Life Artisan' },
    description: {
      ko: '포스트팝의 여러 활동을 중간 단계까지 고르게 이어가요.',
      en: 'Reach the intermediate stage across Postpop activities.',
    },
  },
  mastery_3: {
    name: { ko: '포스트팝 마스터', en: 'Postpop Master' },
    description: {
      ko: '포스트팝의 여러 활동에서 최고 단계에 도달해요.',
      en: 'Reach the highest stage across Postpop activities.',
    },
  },
  playlist_5: {
    name: { ko: '첫 큐레이션', en: 'First Curation' },
    description: {
      ko: '서로 다른 항목 5개 이상인 플리를 만들어요.',
      en: 'Create a playlist with at least five different items.',
    },
  },
  curator_3: {
    name: { ko: '큐레이터', en: 'Curator' },
    description: {
      ko: '조건을 충족한 공개 플리 3개를 만들어요.',
      en: 'Create three public playlists that meet the curation criteria.',
    },
  },
  playlist_20: {
    name: { ko: '긴 호흡의 셀렉션', en: 'The Long Selection' },
    description: {
      ko: '서로 다른 항목 20개 이상인 플리를 만들어요.',
      en: 'Create a playlist with at least 20 different items.',
    },
  },
  curator_10: {
    name: { ko: '열 개의 진열장', en: 'Ten Curated Collections' },
    description: {
      ko: '항목 5개 이상인 플리 10개를 만들어요.',
      en: 'Create 10 playlists with at least five items each.',
    },
  },
  community_days_5: {
    name: { ko: '대화의 시작', en: 'The Conversation Begins' },
    description: {
      ko: '서로 다른 5일에 음악 이야기를 남겨요.',
      en: 'Join music conversations on five different days.',
    },
  },
  community_days_3: {
    name: { ko: '대화의 시작', en: 'The Conversation Begins' },
    description: {
      ko: '서로 다른 3일에 음악 이야기를 남겨요.',
      en: 'Join music conversations on three different days.',
    },
  },
  following_5: {
    name: { ko: '다섯 취향의 연결', en: 'Five Taste Connections' },
    description: {
      ko: '관심 있는 회원 5명을 팔로우해요.',
      en: 'Follow five members whose music records interest you.',
    },
  },
  following_20: {
    name: { ko: '스무 취향의 연결', en: 'Twenty Taste Connections' },
    description: {
      ko: '관심 있는 회원 20명을 팔로우해요.',
      en: 'Follow 20 members whose music records interest you.',
    },
  },
  reactions_10: {
    name: { ko: '공감받는 기록', en: 'A Record That Resonates' },
    description: {
      ko: '내 리뷰와 플리가 서로 다른 10명에게 반응을 얻어요.',
      en: 'Receive reactions to your reviews and playlists from 10 different people.',
    },
  },
  community_days_30: {
    name: { ko: '서른 날의 대화', en: 'Thirty Days of Conversation' },
    description: {
      ko: '서로 다른 30일에 음악 이야기를 남겨요.',
      en: 'Join music conversations on 30 different days.',
    },
  },
  reactions_50: {
    name: { ko: '쉰 사람의 공감', en: 'Fifty Listeners in Tune' },
    description: {
      ko: '내 리뷰와 플리가 서로 다른 50명에게 반응을 얻어요.',
      en: 'Receive reactions to your reviews and playlists from 50 different people.',
    },
  },
  reactions_25: {
    name: { ko: '스물다섯 사람의 공감', en: 'Twenty-Five Listeners in Tune' },
    description: {
      ko: '내 리뷰와 플리가 서로 다른 25명에게 반응을 얻어요.',
      en: 'Receive reactions to your reviews and playlists from 25 different people.',
    },
  },
  streak_3: {
    name: { ko: '3일의 리듬', en: 'Three Days in Rhythm' },
    description: {
      ko: '의미 있는 음악 활동을 3일 연속 이어가요.',
      en: 'Keep up meaningful music activity for three days in a row.',
    },
  },
  streak_7: {
    name: { ko: '일주일의 리듬', en: 'A Week in Rhythm' },
    description: {
      ko: '의미 있는 음악 활동을 7일 연속 이어가요.',
      en: 'Keep up meaningful music activity for seven days in a row.',
    },
  },
  streak_14: {
    name: { ko: '보름의 리듬', en: 'Two Weeks in Rhythm' },
    description: {
      ko: '의미 있는 음악 활동을 14일 연속 이어가요.',
      en: 'Keep up meaningful music activity for 14 days in a row.',
    },
  },
  streak_30: {
    name: { ko: '한 달의 루틴', en: 'A Month in Motion' },
    description: {
      ko: '의미 있는 음악 활동을 30일 연속 이어가요.',
      en: 'Keep up meaningful music activity for 30 days in a row.',
    },
  },
  active_weeks_4: {
    name: { ko: '네 주의 음악 생활', en: 'Four Weeks of Music' },
    description: {
      ko: '한 주에 3일 이상 활동하는 흐름을 4주 이어가요.',
      en: 'Stay active on at least three days a week for four weeks.',
    },
  },
  active_weeks_12: {
    name: { ko: '한 계절의 음악 생활', en: 'A Season of Music' },
    description: {
      ko: '한 주에 3일 이상 활동하는 흐름을 12주 이어가요.',
      en: 'Stay active on at least three days a week for 12 weeks.',
    },
  },
  badges_5: {
    name: { ko: '수집의 시작', en: 'The Collection Begins' },
    description: {
      ko: '컬렉션 외 활동 배지를 5개 획득해요.',
      en: 'Earn five non-collection activity badges.',
    },
  },
  badges_15: {
    name: { ko: '배지 선반', en: 'The Badge Shelf' },
    description: {
      ko: '컬렉션 외 활동 배지를 15개 획득해요.',
      en: 'Earn 15 non-collection activity badges.',
    },
  },
  badges_25: {
    name: { ko: '컬렉션 마스터', en: 'Collection Master' },
    description: {
      ko: '컬렉션 외 활동 배지를 25개 획득해요.',
      en: 'Earn 25 non-collection activity badges.',
    },
  },
  season_participant: {
    name: { ko: '시즌 참가자', en: 'Season Participant' },
    description: {
      ko: '시즌 활동 조건을 한 번 달성해요.',
      en: 'Complete a seasonal activity requirement once.',
    },
  },
  hidden_pathfinder: {
    name: { ko: '숨은 배지', en: 'Hidden Badge' },
    description: {
      ko: '아직 알려지지 않은 탐색 조건을 발견해요.',
      en: 'Discover a hidden exploration requirement.',
    },
  },
};
const sponsorshipStageCopy = {
  support_stage_1: {
    name: { ko: '첫 울림', en: 'First Resonance' },
    description: {
      ko: '첫 검증 후원으로 시작한 기록',
      en: 'The record that begins with your first verified support',
    },
  },
  support_stage_3: {
    name: { ko: '이어지는 리듬', en: 'The Rhythm Continues' },
    description: {
      ko: '후원 혜택과 함께한 누적 3개월',
      en: 'Three cumulative months with active supporter benefits',
    },
  },
  support_stage_6: {
    name: { ko: '한 장의 레코드', en: 'A Record Complete' },
    description: {
      ko: '후원 혜택과 함께한 누적 6개월',
      en: 'Six cumulative months with active supporter benefits',
    },
  },
  support_stage_12: {
    name: { ko: '한 해의 동행', en: 'A Year Together' },
    description: {
      ko: '후원 혜택과 함께한 누적 12개월',
      en: 'Twelve cumulative months with active supporter benefits',
    },
  },
  support_stage_24: {
    name: { ko: '포스트팝 아카이브', en: 'The Postpop Archive' },
    description: {
      ko: '후원 혜택과 함께한 누적 24개월',
      en: 'Twenty-four cumulative months with active supporter benefits',
    },
  },
};
const pick = (copy, locale) => copy[locale];
export function localizeBadge(badge, locale) {
  const copy = badgeCopy[badge.key];
  return copy
    ? { name: pick(copy.name, locale), description: pick(copy.description, locale) }
    : {
        name: badge.name,
        description: badge.description,
      };
}
export function getLocalizedBadgeName(badge, locale) {
  return badgeCopy[badge.key]?.name[locale] ?? badge.name;
}
export function localizeBadgeCategory(category, locale) {
  const copy = categoryCopy[category.key];
  return copy
    ? { name: pick(copy.name, locale), description: pick(copy.description, locale) }
    : {
        name: category.name,
        description: category.description,
      };
}
export function localizeSponsorshipStage(stage, locale) {
  const copy = sponsorshipStageCopy[stage.key];
  return copy
    ? { name: pick(copy.name, locale), description: pick(copy.description, locale) }
    : {
        name: stage.name,
        description: stage.description,
      };
}
